import i18n from 'i18next'
import type { InitOptions } from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// ── Namespaces ────────────────────────────────────────────────────────────────
import de_common from './locales/de/common.json'
import de_shell from './locales/de/shell.json'
import de_fleetops from './locales/de/fleetops.json'
import de_hierarchie from './locales/de/hierarchie.json'
import de_einsatz from './locales/de/einsatz.json'
import de_zeiterfassung from './locales/de/zeiterfassung.json'
import de_hr from './locales/de/hr.json'
import de_kostenstellen from './locales/de/kostenstellen.json'
import de_lieferanten from './locales/de/lieferanten.json'
import de_kostenarten from './locales/de/kostenarten.json'
import de_pca from './locales/de/pca.json'
import de_kasse from './locales/de/kasse.json'
import de_schulen from './locales/de/schulen.json'
import de_haccp from './locales/de/haccp.json'
import de_bot from './locales/de/bot.json'
import de_buero from './locales/de/buero.json'
import en_common from './locales/en/common.json'
import en_shell from './locales/en/shell.json'
import en_fleetops from './locales/en/fleetops.json'
import en_hierarchie from './locales/en/hierarchie.json'
import en_einsatz from './locales/en/einsatz.json'
import en_zeiterfassung from './locales/en/zeiterfassung.json'
import en_hr from './locales/en/hr.json'
import en_kostenstellen from './locales/en/kostenstellen.json'
import en_lieferanten from './locales/en/lieferanten.json'
import en_kostenarten from './locales/en/kostenarten.json'
import en_pca from './locales/en/pca.json'
import en_kasse from './locales/en/kasse.json'
import en_schulen from './locales/en/schulen.json'
import en_haccp from './locales/en/haccp.json'
import en_bot from './locales/en/bot.json'
import en_buero from './locales/en/buero.json'
import fr_common from './locales/fr/common.json'
import fr_shell from './locales/fr/shell.json'
import fr_fleetops from './locales/fr/fleetops.json'
import fr_hierarchie from './locales/fr/hierarchie.json'
import fr_einsatz from './locales/fr/einsatz.json'
import fr_zeiterfassung from './locales/fr/zeiterfassung.json'
import fr_hr from './locales/fr/hr.json'
import fr_kostenstellen from './locales/fr/kostenstellen.json'
import fr_lieferanten from './locales/fr/lieferanten.json'
import fr_kostenarten from './locales/fr/kostenarten.json'
import fr_pca from './locales/fr/pca.json'
import tr_common from './locales/tr/common.json'
import tr_shell from './locales/tr/shell.json'
import tr_fleetops from './locales/tr/fleetops.json'
import tr_hierarchie from './locales/tr/hierarchie.json'
import tr_einsatz from './locales/tr/einsatz.json'
import tr_zeiterfassung from './locales/tr/zeiterfassung.json'
import tr_hr from './locales/tr/hr.json'
import tr_kostenstellen from './locales/tr/kostenstellen.json'
import tr_lieferanten from './locales/tr/lieferanten.json'
import tr_kostenarten from './locales/tr/kostenarten.json'
import tr_pca from './locales/tr/pca.json'

export const defaultNS = 'common'
export const supportedLngs = ['de', 'en', 'fr', 'tr'] as const
export type SupportedLng = (typeof supportedLngs)[number]

export const lngLabels: Record<SupportedLng, string> = {
  de: 'Deutsch',
  en: 'English',
  fr: 'Français',
  tr: 'Türkçe',
}

const options: InitOptions = {
  resources: {
    de: { common: de_common, shell: de_shell, fleetops: de_fleetops, hierarchie: de_hierarchie, einsatz: de_einsatz, zeiterfassung: de_zeiterfassung, hr: de_hr, kostenstellen: de_kostenstellen, lieferanten: de_lieferanten, kostenarten: de_kostenarten, pca: de_pca, kasse: de_kasse, schulen: de_schulen, haccp: de_haccp, bot: de_bot, buero: de_buero },
    en: { common: en_common, shell: en_shell, fleetops: en_fleetops, hierarchie: en_hierarchie, einsatz: en_einsatz, zeiterfassung: en_zeiterfassung, hr: en_hr, kostenstellen: en_kostenstellen, lieferanten: en_lieferanten, kostenarten: en_kostenarten, pca: en_pca, kasse: en_kasse, schulen: en_schulen, haccp: en_haccp, bot: en_bot, buero: en_buero },
    fr: { common: fr_common, shell: fr_shell, fleetops: fr_fleetops, hierarchie: fr_hierarchie, einsatz: fr_einsatz, zeiterfassung: fr_zeiterfassung, hr: fr_hr, kostenstellen: fr_kostenstellen, lieferanten: fr_lieferanten, kostenarten: fr_kostenarten, pca: fr_pca },
    tr: { common: tr_common, shell: tr_shell, fleetops: tr_fleetops, hierarchie: tr_hierarchie, einsatz: tr_einsatz, zeiterfassung: tr_zeiterfassung, hr: tr_hr, kostenstellen: tr_kostenstellen, lieferanten: tr_lieferanten, kostenarten: tr_kostenarten, pca: tr_pca },
  },
  fallbackLng: 'de',
  supportedLngs: [...supportedLngs],
  defaultNS,
  ns: ['common', 'shell', 'fleetops', 'hierarchie', 'einsatz', 'zeiterfassung', 'hr', 'kostenstellen', 'lieferanten', 'kostenarten', 'pca', 'kasse', 'schulen', 'haccp', 'bot', 'buero'],
  interpolation: {
    escapeValue: false,
  },
  detection: {
    order: ['localStorage', 'navigator'],
    lookupLocalStorage: 'mc-erp-lang',
    caches: ['localStorage'],
  },
}

i18n.use(LanguageDetector).use(initReactI18next).init(options)

export default i18n
